/* eslint-disable react/prop-types */
import React from 'react';

export default function AlternativesModal({
  showAlternativesModal,
  setShowAlternativesModal,
  theme,
  exerciseToReplace,
  searchAlternatives,
  isSearchingAlternatives,
  aiRestWarning,
  setShowPlanner,
  alternativeExercises,
  confirmExerciseReplacement
}) {
  if (!showAlternativesModal || !exerciseToReplace) return null;

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-md z-50 flex items-center justify-center p-6 animate-fadeIn">
      <div className={`${theme.card} border ${theme.border} rounded-[2.5rem] p-8 max-w-sm w-full space-y-6 shadow-2xl max-h-[90vh] overflow-y-auto`}>
        
        {/* CABECERA */}
        <div className={`flex justify-between items-center border-b ${theme.border} pb-4`}>
          <div>
            <span className={`text-[9px] font-bold ${theme.muted} uppercase tracking-widest block`}>Sustitución IA</span>
            <h3 className={`text-xl font-black ${theme.text}`}>Cambiar Ejercicio</h3>
          </div>
          <button 
            onClick={() => setShowAlternativesModal(false)} 
            className={`${theme.muted} font-bold text-xl hover:text-red-500 transition-colors`}
          >
            ✕
          </button>
        </div>

        {/* EJERCICIO A REEMPLAZAR */}
        <div className={`${theme.secondary} p-4 rounded-2xl border ${theme.border} space-y-1`}>
          <span className={`text-[9px] ${theme.muted} font-bold uppercase tracking-widest block`}>Ejercicio Original</span>
          <p className={`font-black text-sm ${theme.text}`}>{exerciseToReplace.name}</p>
          <span className="text-[10px] text-emerald-500 font-bold uppercase">{exerciseToReplace.target}</span>
        </div>

        {/* ALERTA DE DESCANSO O LESIÓN */}
        {aiRestWarning && (
          <div className="p-4 bg-amber-500/10 border border-amber-500/30 rounded-2xl space-y-2">
            <p className="text-xs font-bold text-amber-500">⚠️ Recomendación de Descanso</p>
            <p className={`text-[11px] ${theme.muted} leading-relaxed`}>
              La IA ha detectado dolor agudo o molestia. Si persiste, considera tomar un día de descanso o adaptar tu plan.
            </p>
          </div>
        )}

        {/* ESTADO DE CARGA / RESULTADOS */}
        {isSearchingAlternatives ? (
          <div className="py-10 text-center space-y-4">
            <div className="w-10 h-10 border-4 border-t-emerald-500 border-white/20 rounded-full animate-spin mx-auto"></div>
            <p className={`text-xs font-bold ${theme.muted} uppercase tracking-widest`}>Buscando opciones seguras en Supabase...</p>
          </div>
        ) : (
          <div className="space-y-3">
            <span className={`text-[10px] ${theme.muted} font-bold uppercase tracking-widest block`}>Sugerencias de la IA</span>
            {alternativeExercises.length > 0 ? (
              alternativeExercises.map((alt, idx) => (
                <button
                  key={alt.id || idx}
                  onClick={() => confirmExerciseReplacement(alt)}
                  className={`w-full p-4 border ${theme.border} ${theme.secondary} rounded-2xl text-left space-y-2 hover:border-emerald-500 transition-all group`}
                >
                  <div className="flex justify-between items-start">
                    <p className={`font-black text-xs ${theme.text} group-hover:text-emerald-500 transition-colors`}>
                      {alt.name}
                    </p>
                    <span className="text-[10px] font-bold text-emerald-500 bg-emerald-500/10 px-2 py-0.5 rounded-full">
                      {alt.sets || '3-4'} × {alt.reps || '8-12'}
                    </span>
                  </div>
                  {alt.reason && (
                    <p className={`text-[10px] ${theme.muted} leading-snug font-medium`}>
                      {alt.reason}
                    </p>
                  )}
                </button>
              ))
            ) : (
              <p className={`text-xs text-center py-6 ${theme.muted}`}>No se encontraron alternativas disponibles.</p>
            )}
          </div>
        )}

        {/* BOTÓN CANCELAR */}
        <button
          onClick={() => setShowAlternativesModal(false)}
          className={`w-full py-3 border ${theme.border} ${theme.text} font-bold rounded-full text-xs uppercase tracking-widest hover:opacity-80 transition-opacity`}
        >
          Cancelar
        </button>

      </div>
    </div>
  );
}